module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woman@2x_e649bb.png";